import { openModal } from '../helpers/modal';
import OpensetModal from '../services/openset-modal';
export default (openset, translations) => {
    const saveOpenset = (selectedProducts) => {
        const formData = new FormData();
        formData.append('products', JSON.stringify(selectedProducts));
        formData.append('openset', openset.details.sku);
        fetch(openset.options.remoteUrl, {
            method: 'POST',
            cache: 'no-cache',
            body: formData,
        })
            .then((response) => {
            if (response.ok === false) {
                throw new Error('Unknown failure');
            }
            return response.text();
        })
            .then((response) => {
            openModal(response, (modal) => {
                OpensetModal.init(modal, openset.details.sku);
            });
        })
            .catch((err) => {
            console.error(err);
        });
    };
    const setProductTileSelected = (checkbox, productTile) => {
        let selectedText = null;
        let unselectedText = null;
        if (checkbox.parentElement) {
            selectedText = checkbox.parentElement.querySelector('.tile-select-box__selected-text');
            unselectedText = checkbox.parentElement.querySelector('.tile-select-box__unselected-text');
        }
        if (selectedText && unselectedText) {
            if (checkbox.checked) {
                selectedText.style.display = 'inline';
                unselectedText.style.display = 'none';
            }
            else {
                selectedText.style.display = 'none';
                unselectedText.style.display = 'inline';
            }
        }
        if (checkbox.checked) {
            productTile.classList.add('checked');
        }
        else {
            productTile.classList.remove('checked');
        }
    };
    const getSelectedProducts = (checkedProducts) => {
        const selectedProducts = [];
        checkedProducts.forEach((checkedProduct) => {
            const productPriceMeta = checkedProduct.querySelector('meta[itemprop=price]');
            const productSkuMeta = checkedProduct.querySelector('meta[itemprop=sku]');
            if (productPriceMeta && productSkuMeta) {
                const productPrice = productPriceMeta.getAttribute('content');
                const productSku = productSkuMeta.getAttribute('content');
                let quantity = 1;
                if (openset.details.chooseQuantity) {
                    const quantitySelect = checkedProduct.querySelector('.tile-set-choose-quantity select');
                    if (quantitySelect) {
                        quantity = Number(quantitySelect.value) > 0 ? Number(quantitySelect.value) : 1;
                    }
                }
                if (productPrice && productSku) {
                    selectedProducts.push({
                        quantity: quantity,
                        sku: productSku,
                    });
                }
            }
        });
        return selectedProducts;
    };
    const quantityExceeded = (productTile, checkbox) => {
        openModal(translations.alert);
        if (openset.details.chooseQuantity) {
            const quantitySelect = productTile.querySelector('.tile-set-choose-quantity select');
            if (quantitySelect) {
                quantitySelect.value = '1';
            }
        }
        setProductTileSelected(checkbox, productTile);
    };
    const countCheckedProducts = () => {
        const chooseQuantity = openset.details.chooseQuantity;
        const checkedProducts = document.querySelectorAll('.openset-page .prod-tile.checked');
        if (chooseQuantity) {
            let quantity = 0;
            checkedProducts.forEach((product) => {
                const productTile = product.closest('.prod-tile');
                if (!productTile) {
                    return;
                }
                const select = productTile.querySelector('.tile-set-choose-quantity select');
                if (!select) {
                    return;
                }
                quantity += Number(select.value);
            });
            return quantity;
        }
        else {
            return checkedProducts.length;
        }
    };
    const validateAndSave = (checkbox, productTile) => {
        setProductTileSelected(checkbox, productTile);
        const checkedProducts = document.querySelectorAll('.openset-page .prod-tile.checked');
        const notCheckedProducts = document.querySelectorAll('.openset-page .prod-tile:not(.checked)');
        if (countCheckedProducts() == openset.details.productsNumber) {
            notCheckedProducts.forEach((notChecked) => {
                notChecked.classList.add('mask');
            });
        }
        else if (countCheckedProducts() >= openset.details.productsNumber) {
            quantityExceeded(productTile, checkbox);
            return false;
        }
        else {
            notCheckedProducts.forEach((notChecked) => {
                notChecked.classList.remove('mask');
            });
        }
        const selectedProducts = getSelectedProducts(checkedProducts);
        const selectedProductsQuantity = selectedProducts.reduce((tmp, selectedProduct) => {
            return tmp + selectedProduct.quantity;
        }, 0);
        if (selectedProductsQuantity == openset.details.productsNumber) {
            saveOpenset(selectedProducts);
        }
    };
    const opensetProductClickListener = () => {
        document
            .querySelectorAll('.openset-page .prod-tile .tile-select-box label input')
            .forEach((checkbox) => {
            checkbox.addEventListener('change', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const productTile = checkbox.closest('.prod-tile');
                if (!productTile) {
                    return;
                }
                validateAndSave(checkbox, productTile);
            });
        });
    };
    const opensetQuantityChangeClickListener = () => {
        document
            .querySelectorAll('.openset-page .prod-tile .tile-set-choose-quantity select')
            .forEach((quantitySelect) => {
            quantitySelect.addEventListener('change', () => {
                const productTile = quantitySelect.closest('.prod-tile');
                if (!productTile) {
                    return;
                }
                const checkbox = productTile.querySelector('.tile-select-box label input');
                if (!checkbox) {
                    return;
                }
                validateAndSave(checkbox, productTile);
            });
        });
    };
    if (openset.details.productsNumber == countCheckedProducts()) {
        document.querySelectorAll('.openset-page .prod-tile:not(.checked)').forEach((notChecked) => {
            notChecked.classList.add('mask');
        });
    }
    opensetProductClickListener();
    if (openset.details.chooseQuantity) {
        opensetQuantityChangeClickListener();
    }
};
